<script>
import { reactive, onMounted, watch } from 'vue'

export default {
  props: {
    indicador: { type: Object },
  },
  setup(props) {
    const state = reactive({
      total: 0,
      masculino: 0,
      feminino: 0,
    })

    function atualizar(ind) {
      state.total = ind?.total || 0
      state.masculino = ind?.M || 0
      state.feminino = ind?.F || 0
    }

    onMounted(() => atualizar(props.indicador))
    watch(() => props.indicador, (v) => atualizar(v))

    return { state }
  },
}
</script>

<template>
  <div class="card kpi-card kpi-verde text-white h-100">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <div>
          <small class="opacity-75 text-uppercase fw-bold">Alunos</small>
          <div class="kpi-valor">{{ state.total }}</div>
          <small class="opacity-90">matriculados com treinador</small>
        </div>
        <div class="kpi-icon-box">
          <i class="material-icons">school</i>
        </div>
      </div>

      <div class="split">
        <div class="split-item">
          <i class="material-icons">male</i>
          <div>
            <div class="fw-bold">{{ state.masculino }}</div>
            <small>Homens</small>
          </div>
        </div>
        <div class="split-divider"></div>
        <div class="split-item">
          <i class="material-icons">female</i>
          <div>
            <div class="fw-bold">{{ state.feminino }}</div>
            <small>Mulheres</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.kpi-card {
  border: none;
}
.kpi-verde {
  background: linear-gradient(135deg, #22c55e 0%, #15803d 100%);
  box-shadow: 0 4px 12px rgba(21, 128, 61, 0.3);
}

.kpi-valor {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 4px 0;
}

.kpi-icon-box {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.kpi-icon-box i { font-size: 22px; }

.split {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 12px;
}
.split-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.split-item small { opacity: 0.85; }
.split-divider {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.3);
}
</style>
